import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { type FC, type ReactNode, type JSX } from 'react';

export const ContentItemBoxEndIcon: FC<{
    expandedContent?: ReactNode;
    endIcon?: JSX.Element;
    open: boolean;
}> = ({ expandedContent, endIcon, open }) => {
    if (endIcon) return endIcon;

    return expandedContent ? (
        <FontAwesomeIcon
            icon={faChevronDown}
            className={clsx(
                'text-base transition-transform duration-300 hover:text-blue',
                { 'rotate-180 text-blue': open },
                { 'rotate-0 text-slate-grey-400': !open },
            )}
        />
    ) : (
        endIcon
    );
};
